interface SectionProgressBarProps {
  answered: number;
  total: number;
}

export default function SectionProgressBar({
  answered,
  total,
}: SectionProgressBarProps) {
  const fillPercent = total > 0 ? (answered / total) * 100 : 0;

  return (
    <div className="w-full h-1.5 rounded-full overflow-hidden bg-white/10">
      <div
        className="h-full rounded-full transition-all duration-500 ease-out"
        style={{ width: `${fillPercent}%`, background: 'linear-gradient(135deg, #FF3366, #FF8C42)' }}
      />
    </div>
  );
}
